import * as authClient from 'api/authApi';
import * as accountClient from 'api/accountApi';
import * as seatClient from 'api/seatApi';
import * as adminClient from 'api/adminApi';
import * as cohortClient from 'api/cohortApi';
import * as hubClient from 'api/hubApi';
import * as analyticsClient from 'api/analyticsApi';
import * as healthMonitorClient from 'api/healthMonitorApi';
import * as dashboardClient from 'api/dashboardApi';
import * as jobTitleClient from 'api/jobTitleApi';
import * as groupLandingClient from 'api/groupLandingApi';
import * as widgetClient from 'api/widgetApi';

export {
  authClient,
  accountClient,
  seatClient,
  adminClient,
  cohortClient,
  hubClient,
  analyticsClient,
  healthMonitorClient,
  dashboardClient,
  jobTitleClient,
  groupLandingClient,
  widgetClient,
};
